import { translateBlock } from 'i18n';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import glossary from 'helpers/glossaries/fr';
import './_cellar.scss';
import Loading from 'components/Loading';
import NotFound from 'components/Errors/NotFound';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CellarCard from './CellarCard';
import { useGetTableSynopsis } from '../hooks/tableSynopsis';
import TableDetailsHeader from './TableDetailsHeader';

const TableDetails = () => {
    const { t } = useTranslation();
    const { table = '' } = useParams();
    const oudatedGlossary: Record<string, string | undefined> = glossary;

    const [fieldNames, setFieldNames] = useState<string[]>([]);

    const {
        data: tableSynopsis,
        isLoading,
        isError,
    } = useGetTableSynopsis(table);

    useEffect(() => {
        if (!isError && !isLoading && tableSynopsis) {
            const sortedFields = [...tableSynopsis.fields].sort((a, b) =>
                translateBlock(`${table}.${a}`).localeCompare(
                    translateBlock(`${table}.${b}`),
                ),
            );
            setFieldNames(sortedFields);
        }
    }, [tableSynopsis, isLoading, isError]);

    if (isLoading) {
        return (
            <>
                <Box className="table-description">
                    <TableDetailsHeader />
                </Box>
                <Box sx={{ flex: 1, justifyContent: 'center' }}>
                    <Loading />
                </Box>
            </>
        );
    }
    if (!tableSynopsis) {
        return <NotFound />;
    }

    const { meta } = tableSynopsis;
    return (
        <Box className="table-description">
            <TableDetailsHeader />
            <Box className="lines-container">
                <Typography className="number-of-lines" variant="body1">
                    {t('cellar.numberOfLines')}
                    {meta.general.nbLines}
                </Typography>
                {oudatedGlossary[`${table}`] && (
                    <Typography variant="body1">
                        {oudatedGlossary[`${table}`]}
                    </Typography>
                )}

                {meta.relationships.map((relationship) => {
                    const text =
                        relationship.direction === 'MANYTOONE'
                            ? t('cellar.doesReference')
                            : t('cellar.isReferencedBy');
                    return (
                        <Box className="relation" key={relationship.table}>
                            <Typography noWrap variant="body1">
                                {text}{' '}
                                <b>{translateBlock(relationship.table)}</b>
                            </Typography>
                        </Box>
                    );
                })}
            </Box>

            <Box className="card-container">
                {fieldNames.map((fieldName) => (
                    <CellarCard
                        key={fieldName}
                        name={fieldName}
                        table={table}
                    />
                ))}
            </Box>
        </Box>
    );
};

export default TableDetails;
